import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'NiotaClassicCommonTablePageSelector',
  props: {
    page: {
      type: Number,
      required: true,
      default: 1
    },
    tableMaxItems: {
      type: Number,
      required: true,
      default: undefined
    },
    tableItemsPerPage: {
      type: Number,
      required: true,
      default: undefined
    },
    titleTxt: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      currentPage: this.page
    };
  },
  computed: {
    maxPages: function maxPages() {
      return Math.ceil(this.tableMaxItems / this.tableItemsPerPage);
    },
    labelInfo: function labelInfo() {
      return "".concat(this.page, " / ").concat(this.maxPages);
    }
  },
  watch: {
    page: function page(valNew) {
      this.currentPage = valNew;
    }
  },
  methods: {
    setTablePageOnInput: function setTablePageOnInput(num) {
      var numParsed = parseInt(num, 10) || 1;
      var currentPage = Math.min(Math.max(numParsed, 1), this.maxPages);
      this.$emit('page-change', currentPage);
    }
  }
};